import React, { useCallback, useEffect, useRef, useState } from 'react';
import ArticleList from 'components/blog/ArticleList';
import BlogLayout from 'components/blog/BlogLayout';
import FeaturedArticleItem from 'components/blog/FeaturedArticleItem';
import useGetArticles from 'entity/blog/hooks/useGetArticles';
import DropdownSelect from 'seedly-component-library/dropdown-select';
import {
  ArticleCategoryApiResponse,
  GetArticlesByCategoryParams,
} from 'entity/blog/blogTypes';
import { addLinksToArticle } from 'entity/blog/blogUtils';
import blogApi from 'entity/blog/blogApi';

interface OwnProps {
  categoryArticles: {
    articleResponse: ArticleCategoryApiResponse;
    articleParams: GetArticlesByCategoryParams;
  };
}

const CategoryContent = (props: OwnProps) => {
  const { categoryArticles } = props;

  const {
    articles,
    isLoading,
    handleLoadArticles,
    handleLoadArticlesByPage,
    currentPage,
  } = useGetArticles({
    ...categoryArticles,
    articleApi: blogApi.getArticlesByCategory,
  });
  const { category } = categoryArticles.articleResponse.data;

  const [orderBy, setOrderBy] = useState(
    categoryArticles.articleParams.orderBy,
  );

  // Refs
  const scrollToComponent = useRef(null);
  const selectContainer = useRef(null);
  const scrollToSelectContainer = () => {
    scrollToComponent.current(selectContainer.current, {
      offset: -140,
      align: 'top',
      duration: 100,
    });
  };

  const onPageChange = useCallback(
    ({ selected: page }) => {
      scrollToSelectContainer();
      handleLoadArticlesByPage({ page: page + 1, orderBy });
    },
    [handleLoadArticlesByPage, orderBy],
  );

  const onChangeOrder = (orderByParam: string) => {
    handleLoadArticles({
      page: 1,
      orderBy: orderByParam,
      perPage: 10,
      slug: category.slug,
    });
    setOrderBy(orderByParam);
  };

  const SELECT_ITEMS = [
    {
      title: 'Most Recent',
      value: 'publishDate',
      onClick: () => onChangeOrder('publishDate'),
    },
    {
      title: 'Most Popular',
      value: 'views',
      onClick: () => onChangeOrder('views'),
    },
  ];

  // Effects
  useEffect(() => {
    scrollToComponent.current = require('react-scroll-to-component');
  }, []);

  return (
    <BlogLayout stickySidebarDisabled>
      <h1 className="font-bold text-[28px] py-3 px-6 lg:py-0 lg:px-0 lg:pb-8">
        {category.name}
      </h1>
      <FeaturedArticleItem
        {...addLinksToArticle(categoryArticles.articleResponse.data.posts[0])}
      />
      <div className="flex justify-end py-6 mr-4 lg:mr-0" ref={selectContainer}>
        <div className="flex items-center gap-3">
          <p className="font-bold text-sm">Sort by</p>
          <DropdownSelect
            variant="white"
            items={SELECT_ITEMS}
            defaultSelectedItem={SELECT_ITEMS[0]}
            handleSelectedItemchange={item => {
              item.selectedItem.onClick();
            }}
          />
        </div>
      </div>
      <div className="pb-6">
        <ArticleList
          articles={articles.slice(1)}
          currentPage={currentPage}
          totalPage={categoryArticles.articleResponse.data.totalPages}
          onPageChange={onPageChange}
          loading={isLoading}
        />
      </div>
    </BlogLayout>
  );
};

export default CategoryContent;
